export default {
    clientInstruction:
        "Clients' TRNs can be edited from the Clients' Summary pages.",
    clientTitle: 'Client TRN',
    partnerInstruction:
        'To register or change your Tax Registration Number in MakeLeaps, visit the <0>Your Company page.</0>',
    partnerTitle: 'Your Company TRN',
    subTitle:
        'The Document Types that will show your Tax Registration Number (TRN). Only affects MakeLeaps stock document templates.',
    successMessage: 'TRN Display settings modified.',
    title: 'TRN Display',
};
